import { useState } from 'react';
import { Environment } from '@components/community/constants';

const NEWSLETTER_FORM_TYPE = 'community_learning_signup';
const NEWSLETTER_FORM_DEF = 'pointALead';

const WAC_BASE_URL = {
  [Environment.LOCAL]: '/api/wac',
  [Environment.DEVELOPMENT]: 'https://wac.stg.internal.atlassian.com', //  WAC dev env is unavailable for this endpoint
  [Environment.STAGING]: 'https://wac.stg.internal.atlassian.com',
  [Environment.PRODUCTION]: 'https://www.atlassian.com',
};

export type NewsletterFormValues = {
  email: string;
  firstname?: string;
  lastname?: string;
  anonymousId?: string;
  atlassianId?: string;
};

// Initiates POST to /streamhub/wacformlead
// Endpoint in: https://bitbucket.org/atlassian/bxp-express/src/routes/streamhubSubmission.ts
const postNewsletterSignup = async (formValues: NewsletterFormValues, environment: Environment): Promise<Response> => {
  const requestOptions = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      ...formValues,
      formType: NEWSLETTER_FORM_TYPE,
      formDef: NEWSLETTER_FORM_DEF,
    }),
  };
  return fetch(WAC_BASE_URL[environment] + '/endpoint/streamhub/wacformlead', requestOptions);
};

export const usePostNewsletterSignup = (
  environment: Environment = Environment.DEVELOPMENT,
): {
  handleNewsletterSignup: (formValues: NewsletterFormValues) => Promise<void>;
  loading: boolean;
  error: string | null;
  success: boolean;
} => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleNewsletterSignup = async (formValues: NewsletterFormValues): Promise<void> => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await postNewsletterSignup(formValues, environment);
      if (!response.ok || response.status !== 200) {
        throw new Error(`Error with status: ${response.status}`);
      }
      setSuccess(true);
    } catch (err: any) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { handleNewsletterSignup, loading, error, success };
};
